import { FC, useContext, useEffect, useState } from "react";

import { Button, Col, Row, Space } from "antd";
import { AppContext } from "App";
import googleIcon from "assets/images/google.svg";
// import appleLogoWhite from "assets/images/home/apple-logo-white.svg";
import hmrcCrown from "assets/images/home/hmrc-crown.svg";
import FloatInput from "components/inputs/Form/Inputs/FloatInput";
import { useNavigate } from "react-router-dom";

import { getStars } from "./getStars";

interface MainProps {
    setShowButtonFooter: (_value: boolean) => void;
}

const Main: FC<MainProps> = ({ setShowButtonFooter }) => {
    const [email, setEmail] = useState<string>("");
    const navigate = useNavigate();
    const { isMobile } = useContext(AppContext);

    useEffect(() => {
        if (isMobile) {
            setShowButtonFooter(true);
        }
    }, [isMobile, setShowButtonFooter]);

    return (
        <div className={"main horizontal-center"}>
            <div className={"main__header"}>
                <h1 className="main__title">
                    <span className="main__title-underline"><span className="main__sparkle">
                        Smart
                    </span> Taxes</span><br/>
                    <span>Zero Stress</span>
                </h1>
                <div className={"fs16 grey-7-color"}>{"Intuitive tax software designed for real people, not tax professionals."}</div>
            </div>

            <div className="main__email-collection">
                <Space.Compact className="w100">
                    <FloatInput
                        required
                        placeholder="Enter your email"
                        onChange={event => setEmail(event.target.value)}
                    />
                    <Button
                        type="primary"
                        size="large"
                        className="fs16"
                        onClick={() => navigate("/sign-up?step=personalInfo", { state: { email } })}
                    >
                        Get Started
                    </Button>
                </Space.Compact>
                {/* <Typography.Text className="fs12 grey-5-color mt10">
                    Continue with
                </Typography.Text>
                <Space className="mt10 mb10">
                    <button className="shared__secondary-button bg-white">
                        <img src={googleIcon} width={16} height={16} alt="Google" />
                        <span className="fs16 black-color ml6">Google</span>
                    </button>
                    <button className="shared__secondary-button bg-black">
                        <img src={appleLogoWhite} width={16} height={16} alt="Apple" />
                        <span className="fs16 white-color ml6">Apple</span>
                    </button>
                </Space> */}
            </div>

            <div className="main__hmrc-recognition center">
                <img
                    src={hmrcCrown}
                    width={32}
                    height={32}
                    alt="HMRC Crown"
                    className="main__hmrc-crown"
                />
                <span className="fs16 grey-7-color ml10">
                    {"HMRC Recognised Software"}
                </span>
            </div>

            <Row gutter={[32, 16]} className={"main__reviews"}>
                {[
                    {
                        id: "google",
                        label: "Google Reviews",
                        score: 4.7,
                        icon: googleIcon,
                    },
                ].map(item => {
                    return (
                        <Col
                            key={item.id}
                            sm={24}
                            xs={24}
                            md={24}
                            lg={24}
                            xl={9}
                        >
                            <div className={"horizontal-left"}>
                                <div>
                                    <img
                                        src={item.icon}
                                        width={36}
                                        height={36}
                                        alt={item.id}
                                    />
                                </div>
                                <div className={"ml10"}>
                                    <div className={"grey-7-color bold fs12"}>
                                        {item.label}
                                    </div>
                                    <div className={"horizontal-left"}>
                                        <div className={"fs18 bold"}>
                                            {item.score}
                                        </div>
                                        <div className={"ml10"}>
                                            {getStars(5, 22)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
};

export default Main;
